import type { HResponse } from '@/lib/hfetch/types';
import { onMounted, ref } from 'vue';

export const useHFetchQuery = <T>(hFetchMethod: () => Promise<HResponse<T>>) => {
  const data = ref<T | null>(null);
  const errors = ref<string[] | null>(null);
  const isLoading = ref(true);

  const executeFetch = async () => {
    isLoading.value = true;
    errors.value = null;

    const response = await hFetchMethod();
    if (response.status === 'success') {
      data.value = response.data;
    } else {
      errors.value = response.messages;
      data.value = null;
    }

    isLoading.value = false;
  };

  const reload = async () => {
    if (isLoading.value) return;
    await executeFetch();
  };

  onMounted(() => {
    executeFetch();
  });

  return {
    data,
    errors,
    isLoading,
    reload,
  };
};
